import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination } from '@mui/material';
import { useState } from 'react';
import { Event } from '../type';
import { formatDate } from '../utils/dateUtils';
import { Timestamp } from '@firebase/firestore';

interface EventTableProps {
  data: Event[];
  onEventSelect: (event: Event) => void;
}

export const EventTable = ({ data, onEventSelect }: EventTableProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const pagedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const isEventActive = (startDate: Timestamp, endDate: Timestamp) => {
    const now = new Date();
    const start = startDate instanceof Timestamp ? startDate.toDate() : new Date(startDate);
    const end = endDate instanceof Timestamp ? endDate.toDate() : new Date(endDate);
    return now >= start && now <= end;
  };

  return (
    <Box sx={{ width: '100%' }}>
        <TableContainer>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell>이벤트 ID</TableCell>
                <TableCell>제목</TableCell>
                <TableCell>배너</TableCell>
                <TableCell>시작일</TableCell>
                <TableCell>종료일</TableCell>
                <TableCell>상태</TableCell>
                <TableCell>공개</TableCell>
                <TableCell>공개위치</TableCell>
                <TableCell>공개순서</TableCell>
                <TableCell>팝업표시</TableCell>
                <TableCell>생성일</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {pagedData.map((event, index) => (
                <TableRow key={event.eventId || `event-${index}`} hover style={{ cursor: 'pointer' }} onClick={() => onEventSelect(event)}>
                  <TableCell>{event.eventId}</TableCell>
                  <TableCell>{event.title}</TableCell>
                  <TableCell>
                    {event.bannerImageUrl ? 'O' : 'X'}
                  </TableCell>
                  <TableCell>{formatDate(event.startDate)}</TableCell>
                  <TableCell>{formatDate(event.endDate)}</TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'inline-block',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        backgroundColor: isEventActive(event.startDate, event.endDate) 
                          ? '#e8f5e8' 
                          : (event.startDate instanceof Timestamp ? event.startDate.toDate() : new Date(event.startDate)) > new Date() 
                            ? '#fff3e0' 
                            : '#ffebee',
                        color: isEventActive(event.startDate, event.endDate) 
                          ? '#2e7d32' 
                          : (event.startDate instanceof Timestamp ? event.startDate.toDate() : new Date(event.startDate)) > new Date() 
                            ? '#f57c00' 
                            : '#c62828',
                      }}
                    >
                      {isEventActive(event.startDate, event.endDate) 
                        ? '진행중' 
                        : (event.startDate instanceof Timestamp ? event.startDate.toDate() : new Date(event.startDate)) > new Date() 
                          ? '예정' 
                          : '종료'}
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box
                      sx={{
                        display: 'inline-block',
                        px: 1,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '0.75rem',
                        fontWeight: 'bold',
                        backgroundColor: event.isPublic ? '#e8f5e8' : '#ffebee',
                        color: event.isPublic ? '#2e7d32' : '#c62828',
                      }}
                    >
                      {event.isPublic ? '전체공개' : ((event.allowedEnterprises?.length ?? 0) > 0 || (event.allowedUsers?.length ?? 0) > 0) ? '공개' : '비공개'}
                    </Box>
                  </TableCell>
                  <TableCell>{event.placement}</TableCell>
                  <TableCell>{event.order ? event.order : 0}</TableCell>
                  <TableCell>{event.isPopup ? 'O' : 'X'}</TableCell>
                  <TableCell>{formatDate(event.createdAt)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={data.length}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
        />
    </Box>
  );
}; 